@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../../../../constants/spacing.module.less';

.flags-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: @space-8;
}

.flag-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: @space-12;
  padding: @space-12;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  width: 100%;
}

/* Override Button unstyled reset — background/border are the card's visual identity */
.flags-grid .flag-card {
  border: 1px solid var(--gray-CFD1D3);
  background: var(--white);
}

.flags-grid .flag-card-checked {
  background: var(--blue-EDF6FF);
  border-color: var(--blue-DBECFE);
}

.flag-checkbox {
  flex-shrink: 0;
}

.flag-icon {
  flex-shrink: 0;
  color: var(--gray-637381);
}

.flag-icon-checked {
  color: var(--blue-1D5AD8);
}

.flag-label {
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  color: var(--gray-212c36);
}

.flag-hint {
  font-size: 12px;
  line-height: 20px;
  color: var(--gray-637381);
  white-space: nowrap;
}
